import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/App-Context";

import axios from "axios";

const TgridAmindLogin = () => {
  const auth = useContext(AuthContext);

  const navigate = useNavigate();
  // In handleSubmit, after success:

  //////// post request , axios

  ///
  ///
  ///
  ///

  const [credentials, setCredentials] = useState({
    usernameOrEmail: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  ///////////////////////////////////////

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    //console.log(credentials.usernameOrEmail);
    //console.log(credentials.password);

    /////// problem vvvvv

    try {
      // Make POST request to your API endpoint
      const response = await axios.post(
        "http://localhost:5000/api/amindUse/zeusapolis/amindLawLogin",
        {
          loginVar: credentials.usernameOrEmail,
          password: credentials.password,
        },
        { withCredentials: true }
      );

      // console.log("request made");
      // console.log(response);

      // Handle successful response (e.g., store token, redirect)
      setSuccess("Login successful!");
      auth.TGRIDAMIND_login(response.data.data.TGRIDAMIND_loginVar);
      ///console.log("Response:", response.TGRIDAMIND_data); // Example: { token: 'xyz' }
      // Optional: Store token in localStorage or redirect
      //   localStorage.setItem(
      //     "TGRIDAMIND_token",
      //     response.data.data.TGRIDAMIND_token
      //   );
      // Redirect to dashboard or protected route
      // window.location.href = '/dashboard';
      navigate("/admin-go/Start-TempleGrid");
      // console.log("navigated");
    } catch (err) {
      // Handle errors (e.g., invalid credentials, server error)
      setError(
        err.response?.data?.message || "Login failed. Please try again."
      );
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="path">zeus admin</div>
      <div className="door-frame">
        <div className="door-molding">
          <form onSubmit={handleSubmit}>
            <div className="door-molding-crown">username</div>
            <div>
              <input
                type="usernameOrEmail"
                name="usernameOrEmail"
                id="usernameOrEmail"
                value={credentials.usernameOrEmail}
                onChange={handleChange}
                // onChange={handleChange} production soon
                required
                placeholder="username or email"
                className="door-molding-etching"
              />
            </div>
            <div className="door-molding-crown">password</div>
            <div>
              <input
                type="password"
                name="password"
                id="password"
                onChange={handleChange}
                value={credentials.password}
                // onChange={handleChange} production soon
                required
                placeholder="username or email"
                className="door-molding-etching"
              />
            </div>
            {/* {loading & <div>loading</div>} */}
            <div className="door-handle-enter">
              <button className="door-handle-enter" type="submit">
                login
              </button>
            </div>
            {/* <div className="door-handle-navigate-login">
              <Link to="/signup">sign up</Link>
            </div> */}
            {/* <div className="door-handle-navigate-forgotpw">
              <Link to="/login">forgot password</Link>
            </div> */}
          </form>
        </div>
      </div>
      <div className="greeterblock">
        <div className="greeterleft">Zeusdb&copy;</div>
        <div className="greeterright">z</div>
      </div>
    </div>
  );
};

export default TgridAmindLogin;
